

import React, { useEffect, useRef, useState } from "react"
import { renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { ConfirmarEtapaProducao } from "./ConfirmarEtapaProducao";

type ConfirmarEtapaProducaoContainerProps = {
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
}

export const ConfirmarEtapaProducaoContainer = (props: ConfirmarEtapaProducaoContainerProps) => {

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const onRenderizarConfirmarEtapaProducao = () => renderizarComponentReact(
        <ConfirmarEtapaProducaoContainer {...props}/>, "ordem-de-producao-region", true
    )

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Confirmação etapa de produção", () => onRenderizarConfirmarEtapaProducao())
    }, [])


    return (
        <>

            <Breadcrumb2Container
                id="ConfirmarEtapaProducaoContainer"
                passos={passosInterno?.current?.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <ConfirmarEtapaProducao
                onOk={() => { }}
            />
        </>
    )
}